/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspostcategory_Sort2Inputs */

const vi_cmspostcategory_sort2 = /** @type {(inputs: Cmspostcategory_Sort2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thứ tự`)
};

/**

* @param {Cmspostcategory_Sort2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspostcategory_sort2 = /** @type {((inputs?: Cmspostcategory_Sort2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspostcategory_Sort2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspostcategory_sort2(inputs)
});
export { cmspostcategory_sort2 as "cmsPostCategory_sort" }